"use client";
import { useMediaQuery } from "@mui/material";
import { createTheme, useTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    custom: {
      success: "#00C046",
      warning: "#FF8500",
      primary: "#0B65B5",
      danger: "#FF3850",
      white: "#FFFFFF",
      walletBg: "#e0f2ff",
      walletFont: "#232323",
      walletAmount: "#007aff",
      iconBg: "#e0e0e0",
      sidebarBg: "#1565C0",
      searchBg: "#F3F3F3",
      hover: "#E67600",
      orderCards: "#126ABC",
      orderName: "#0B2373",
      errorBg: "#FFEBEE",
      rowBg: "#D7ECFF",
      lightBack: "#616161",
      custom: "#eeeeee",
      lightPink: "#dadce0",
      lightGrey: "#212121",
      packColor: "#575757",
      packIconColor: "#1A1A1A",
      packTestColor: "#5994FF",
      chipColor: "#46BBFF",
      textColor: "#03336E",
      chipPaid: "#b0dcb9",
      chipBackground: "#D9DFE6",
      chipSelfBackground: "#D9DFE6",
      blackColor: "#000000",
      lockerValueColor: "#4C4C4C",
      orderButtonColor: "#757575",
      orderButtonBackground: "#BDBDBD",
      successStepper: "#9C9C9C",
      chatBoxColor: "#E5F3FF",
      typeText: "#9C9C9C",
      listGroupColor: "#A6A6A6",
      chipsBgColor: "#CAE6FF",
      screenBgColor: "#f3faff",
      assistBgColor: "#f3faff",
      imageColor: "#FF9225",
      profileText: "#393939",
      profileTextUpdate: "#393939",
      tabColor: "#EAEAEA",
      uploadColor: "#E17B0B",
      textInfo: "#272727",
      profileSuccess: "#101828",
      profileSuccessDes: "#475467",
      virtualTitle: "#344054",
      virtualDescription: "#505154",
      virtualSuccess: "#f1f4f7",
      notProvide: "#969696",
      provideBg: "#1B1B1B",
      provideColor: "#454545",
      pictureBg: "#E3F2FF",
      chipUnderBg: "#FFD2D2",
      chipReachBg: "#FFF5B3",
      chipPackBg: "#A5FAB2",
      senderTextColor: "#D71515",
      OrderTextColor: "#04182C",
      productTextColor: "#3C3D3E",
      startInputBgColor: "#D1D3D4",
      startInputColor: "#696969",
      uploadProductColor: "#FF8C0E",
      shopperAssignedColor: "#323232",
      shopperAssignedDesColor: "#363636",
      chatGroupBg: "#E6F3FF",
      chatGroupDesBg: "#FEF8F1",
      radioBgColor: "#FF7F2A",
      radioBg: "#FFF6E5",
      tabBg: "#EAF5FF",
      chipJoinColor: "#089318",
      chipJoinBg: "#D6FFE0",
      pendChipBg: "#FFEBD6",
      pendChipColor: "#935108",
      tabBackgroundColor: "#eef5fc",
      selectTabBackgroundColor:'#fff6ec'
    },
  },

  breakpoints: {
    values: {
      xs: 376,
      mb: 959,
      sm: 600,
      md: 960,
      lg: 1200,
      xl: 1440,
      xxl: 1651,
    },
  },
  borderRadius: {
    radius: {
      regular: "24px",
      wallet: "8px",
      medium: "12px",
      custom: "16px",
      small: "6px",
      large: "20px",
      extraLarge: "100px",
    },
  },
  padding: {
    size: {
      small: "10px",
      medium: "15px",
      large: "20px",
    },
    horizontal: {
      small: "5px 10px",
      medium: "8px 16px",
      large: "12px 24px",
    },
  },
  typography: {
    toLargeText: {
      fontSize: "48px",
    },
    notFoundLarge: {
      fontSize: "96px",
    },
    "5xl": {
      fontSize: "40px",
    },
    "4xl": {
      fontSize: "35px",
    },

    "2xl": {
      fontSize: "32px",
    },
    fontWeight: {
      medium: 500,
      semiBold: 600,
      bold: 700,
    },
    "3xl": {
      fontSize: "30px",
    },
    xxLarge: {
      fontSize: "28px",
    },
    customLarge: {
      fontSize: "26px",
    },
    xLarge: {
      fontSize: "24px",
    },

    extraLarge: {
      fontSize: "22px",
    },
    large: {
      fontSize: "20px",
    },
    base: {
      fontSize: "18px",
    },
    regular: {
      fontSize: "16px",
    },
    small: {
      fontSize: "14px",
    },
    medium: {
      fontSize: "15px",
    },
    extraSmall: {
      fontSize: "12.8px",
    },
    micro: {
      fontSize: "11px",
    },
    button: {
      textTransform: "none",
      fontWeight: 600,
    },
    mini: {
      fontSize: "12px",
    },
    tiny: {
      fontSize: "10px",
    },
    chipColor: {
      fontSize: "9px",
    },
    tinySmall: {
      fontSize: "13px",
    },
    xlBreakpoint: {
      fontSize: "7px",
    },
    xSmall: {
      fontSize: "8px",
    },
  },
  shape: {
    custom: {
      smallRadius: "4px",
      regularRadius: "8px",
      largeRadius: "10px",
    },
  },

  borders: {
    default: `1px solid #BEBEBE`,
    warning: `1px solid #FF8500`,
    highlighted: `1px solid #CAE6FF`,
    defaultButton: "1px solid #4C4C4C",
    cardBorder: "1px solid #FEF8F1",
    boxBorder: "1px solid #D1D3D4",
    orderCards: "1px solid #126ABC",
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        html: {
          scrollbarColor: "#0B65B5 transparent",
        },
        body: {
          scrollbarColor: "#0B65B5 transparent",
        },
        "*::-webkit-scrollbar": {
          width: "2px",
          height: "2px",
        },
        "*::-webkit-scrollbar-track": {
          background: "transparent",
        },
        "*::-webkit-scrollbar-thumb": {
          backgroundColor: "#0B65B5",
          borderRadius: "8px",
        },
        "*::-webkit-scrollbar-thumb:hover": {
          backgroundColor: "#126ABC",
        },
      },
    },
  },
});
export const useIsMobile = () => {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down("mb"));
};
export default theme;
